import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { discountSchema, DiscountFormValues } from "@modules/discounts/validations/discountSchema";
import { useCreateDiscountMutation } from "@modules/discounts/services/mutations";

export function useDiscountCreateForm() {
  const { mutateAsync, isPending } = useCreateDiscountMutation();

  const methods = useForm<DiscountFormValues>({
    resolver: zodResolver(discountSchema()),
    defaultValues: {
      active: true,
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
